import React from 'react';

import { getSortablePeriodLabels } from '@trqk/utils';

interface StatementPeriodProps {
    isNew: boolean;
    statementView: TrqkStatementView;
    width: number;
}

const defaultResult = '-';

/**
 * Displays a statement period with the year first, like '2019 Q2'
 * @param {StatementPeriodProps} props
 */
export function StatementPeriod(props: StatementPeriodProps): JSX.Element {
    const { isNew, statementView } = props;

    const period = {
        start_date: statementView?.start_date ?? null,
        end_date: statementView?.end_date ?? null,
    };

    const sortablePeriodLabels = getSortablePeriodLabels(period);
    const newDot = !isNew ? null : (
        <div
            className="mx-1 bg-secondary-500 rounded-full"
            style={{ width: 6, height: 6 }}
        />
    );

    if (sortablePeriodLabels.short !== null) {
        return (
            <div
                className="flex items-center justify-start"
                style={{ width: props.width }}
            >
                {sortablePeriodLabels.short}
                {newDot}
            </div>
        );
    }

    if (sortablePeriodLabels.long !== null) {
        return (
            <div className="flex items-center justify-start">
                <div
                    className="respond-to-mouse leading-tight clamp-2-lines"
                    style={{
                        width: !isNew ? props.width : props.width - 14,
                    }}
                >
                    {sortablePeriodLabels.long}
                </div>
                {newDot}
            </div>
        );
    }

    return (
        <div
            className="flex items-center justify-start"
            style={{ width: props.width }}
        >
            {defaultResult}
            {newDot}
        </div>
    );
}
